import React, { useState, useEffect } from "react";

export const TerijReport = ({ combinedData, schoolData, totalsByKhate,fyear, onClose }) => {
  const taluka = schoolData ? schoolData.taluka : "";
  const jilha = schoolData ? schoolData.jilha : "";
  const [language, setLanguage] = useState(localStorage.getItem("language") || "English");
  const [attachedCredit, setAttachedCredit] = useState("");
  const [studentFeeTotal, setStudentFeeTotal] = useState(0);
  const udiseNumber = localStorage.getItem("udiseNumber");

  // Helper function to format numbers
  const formatNumber = (num) => (num ? num.toFixed(2) : "");

  // Total Calculation
  let totalCredit = 0;
  let totalDebit = 0;

  // Store the opening balance separately
  const openingBalanceCredit = totalsByKhate["31-03-Akher shillak"]
    ? totalsByKhate["31-03-Akher shillak"].credit
    : 0;
  const openingBalanceDebit = totalsByKhate["31-03-Akher shillak"]
    ? totalsByKhate["31-03-Akher shillak"].debit
    : 0;

  // Get kird with fee attach data from IndexedDB
const getKirdWithFeeattachData = async () => {
    console.log("Attempting to fetch fee attachment data from IndexedDB...");
    if (!fyear) {
      console.error("Financial year not found in localStorage");
      throw new Error("Financial year not found");
    }

    return new Promise((resolve, reject) => {
      const openRequest = indexedDB.open('SchoolManagementDB', 1);
      
      openRequest.onerror = (event) => {
        console.error("Database opening error:", event.target.error);
        reject(event.target.error);
      };

      openRequest.onsuccess = (event) => {
        const db = event.target.result;
        console.log("Database opened successfully");
        
        try {
          if (!db.objectStoreNames.contains('kirdWithFeeattach')) {
            console.warn("kirdWithFeeattach object store doesn't exist");
            resolve(null);
            return;
          }

          const transaction = db.transaction(['kirdWithFeeattach'], 'readonly');
          const objectStore = transaction.objectStore('kirdWithFeeattach');
          
          console.log(`Querying for financial year: ${fyear}`);
          const getRequest = objectStore.get(fyear);
          
          getRequest.onerror = (event) => {
            console.error("Data retrieval error:", event.target.error);
            reject(event.target.error);
          };
          
          getRequest.onsuccess = (event) => {
            const result = event.target.result;
            console.log("Retrieved fee attachment data:", result);
            resolve(result);
          };
        } catch (error) {
          console.error("Transaction error:", error);
          reject(error);
        }
      };

      openRequest.onupgradeneeded = (event) => {
        console.log("Database upgrade needed");
        const db = event.target.result;
        if (!db.objectStoreNames.contains('kirdWithFeeattach')) {
          console.log("Creating kirdWithFeeattach object store");
          db.createObjectStore('kirdWithFeeattach', { keyPath: 'fyear' });
        }
      };
    });
  };


  // Fetch combined student fees
 const fetchCombinedStudentFees = async () => {
    console.log("Starting student fee fetch process...");
    try {
      if (!udiseNumber || !fyear) {
        console.warn("Missing required data:", { udiseNumber, fyear });
        return;
      }

      console.log("Fetching fee attachment data from IndexedDB...");
      const kirdData = await getKirdWithFeeattachData();
      
      if (!kirdData) {
        console.log("No fee attachment data found in IndexedDB");
        return;
      }

      console.log("Retrieved kirdData:", kirdData);
      
      if (kirdData.typeofattach === "combinedPavati") {
        console.log("Found combinedPavati attachment type");
        const creditAccount = kirdData.creditKhate || "";
        console.log(`Setting credit account to: ${creditAccount}`);
        setAttachedCredit(creditAccount);
        
        // Fetch student fees from Firebase
        const studentFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${fyear}.json`;
        console.log(`Fetching student fees from: ${studentFeesUrl}`);
        
        const response = await fetch(studentFeesUrl);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch student fees: ${response.status}`);
        }
        
        const studentFees = await response.json();
        console.log("Raw student fees data:", studentFees);
        
        let totalStudentFees = 0;
        const lastBeforePayMap = {};

        if (studentFees) {
          console.log("Processing student fees...");
          for (const serialNo in studentFees) {
            for (const invoiceNo in studentFees[serialNo]) {
              const feeData = studentFees[serialNo][invoiceNo];
              
              for (const feeType in feeData) {
                const feeDetails = feeData[feeType];
                const previousTotal = lastBeforePayMap[`${serialNo}_${feeType}`] || 0;
                const currentBeforePay = parseFloat(feeDetails.beforePay) || 0;
                const paidAmount = currentBeforePay - previousTotal;

                if (paidAmount > 0) {
                  console.log(`Found payment: ${paidAmount} for student ${serialNo}`);
                  totalStudentFees += paidAmount;
                  lastBeforePayMap[`${serialNo}_${feeType}`] = currentBeforePay;
                }
              }
            }
          }
        }

        console.log(`Total student fees calculated: ${totalStudentFees}`);
        setStudentFeeTotal(totalStudentFees);
      } else {
        console.log("No combinedPavati attachment found");
      }
    } catch (error) {
      console.error("Error in fetchCombinedStudentFees:", error);
    }
  };

  // Debug useEffect
  useEffect(() => {
    console.log("Component mounted or updated");
    console.log("Current state:", {
      attachedCredit,
      studentFeeTotal,
      udiseNumber,
      fyear
    });
    
    fetchCombinedStudentFees();
  }, []);

  // Debug render
  useEffect(() => {
    console.log("Render state update:", {
      attachedCredit,
      studentFeeTotal,
      totalsByKhate
    });
  }, [attachedCredit, studentFeeTotal, totalsByKhate]);


  // Print function
  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");
    const printWindow = window.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              margin: 0;
            }
            h1, h3 {
              text-align: center;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
            }
            th, td {
              padding: 10px;
              text-align: center;
              border: 1px solid #000;
            }
            th {
              background-color: #A31D27;
              color: #fff;
            }
            .opening-balance {
              background-color: #C5C6C7;
            }
            .closing-balance {
              background-color: #C5C6C7;
            }
            .total-row {
              background-color: #ffeb3b;
            }
            .student-fee-row {
              background-color: #e8f5e9;
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  return (
    <div style={report2Overlay}>
      <div style={report2Container}>
        <button style={closeButtonStyle2} onClick={onClose}>Close</button>
        <button onClick={handlePrint} style={{ margin: "20px" }}>
          Print Report
        </button>

        <div
          id="printableContent"
          style={{
            padding: "20px",
            maxWidth: "1200px",
            margin: "0 auto",
            fontFamily: "Arial, sans-serif",
            border: "1px solid #000",
            boxSizing: "border-box",
            overflowY: "auto",
            maxHeight: "70vh",
          }}
        >
          {/* School Info Section */}
          <div
            style={{
              backgroundColor: "#f0f0f0",
              padding: "20px",
              marginBottom: "20px",
              textAlign: "center",
              border: "1px solid #000",
            }}
          >
            <h1
              style={{
                margin: "0",
                fontSize: "24px",
                fontWeight: "bold",
              }}
            >
              {schoolData.schoolName}
            </h1>
            <p
              style={{
                margin: "5px 0",
                fontSize: "16px",
              }}
            >
              {language === "English" ? "Taluka: " : "तालुका: "} {taluka},{" "}
              {language === "English" ? " District: " : " जिल्हा: "} {jilha}
            </p>
            <p
              style={{
                margin: "5px 0",
                fontSize: "16px",
              }}
            >
              {language === "English" ? "Email: " : "ई-मेल: "} {schoolData.email},{" "}
              {language === "English" ? "Mobile Number: " : "मोबाईल नंबर "}{" "}
              {schoolData.mobileNumber}
            </p>
          </div>

          {/* Title */}
          <h3
            style={{
              textAlign: "center",
              backgroundColor: "#000",
              color: "#fff",
              padding: "4px",
              display: "block",
              width: "fit-content",
              margin: "0 auto",
              borderRadius: "10px",
              marginBottom: "10px",
              fontSize: "20px",
            }}
          >
            {language === "English" ? "Balance Sheet Report " : "तेरीज पत्र "}
          </h3>

          {/* Table Header */}
          <table
            style={{
              width: "1000px",
              maxWidth: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
              margin: "0 auto",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    border: "1px solid #000",
                    backgroundColor: "#A31D27",
                    color: "#fff",
                  }}
                >
                  <b>{language === "English" ? "Account Name  " : "खात्याचे नाव "}</b>
                </th>
                <th
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    border: "1px solid #000",
                    backgroundColor: "#A31D27",
                    color: "#fff",
                  }}
                >
                  <b>{language === "English" ? "Credit Amount " : "जमा रक्कम"}</b>
                </th>
                <th
                  style={{
                    padding: "10px",
                    textAlign: "center",
                    border: "1px solid #000",
                    backgroundColor: "#A31D27",
                    color: "#fff",
                  }}
                >
                  <b>{language === "English" ? "Debit Amount " : "नावे रक्कम"}</b>
                </th>
              </tr>
            </thead>

            <tbody>
              {/* Opening Balance Row */}
              {totalsByKhate["31-03-Akher shillak"] && (
                <>
                  <tr
                    style={{
                      backgroundColor: "#C5C6C7",
                    }}
                  >
                    <td
                      style={{
                        fontWeight: "bold", border: "1px solid #000",
                      }}
                    >
                      <b>{language === "English" ? "Opening Balance" : "आरंभिक "}</b>
                    </td>
                    <td style={{ border: "1px solid #000"}} >{formatNumber(openingBalanceCredit)}</td>
                    <td style={{ border: "1px solid #000"}}>{formatNumber(openingBalanceDebit)}</td>
                  </tr>
                  {/* Removing the entry */}
                  {delete totalsByKhate["31-03-Akher shillak"]}
                </>
              )}

              {/* Student Fee Row - Only show if connected */}
              {attachedCredit && studentFeeTotal > 0 && (
                <tr className="student-fee-row">
                  <td style={{ border: "1px solid #000"}}>
                    {attachedCredit} <br />
                    <small style={{color: '#836459'}}>
                      {language === "English" ? "Student Fees" : "विद्यार्थी फी"}
                    </small>
                  </td>
                  <td style={{ border: "1px solid #000"}}>{formatNumber(studentFeeTotal)}</td>
                  <td style={{ border: "1px solid #000"}}></td>
                </tr>
              )}

              {/* Loop Through Khates */}
              {Object.keys(totalsByKhate).map((khateName) => {
                const { credit, debit } = totalsByKhate[khateName];
                totalCredit += credit || 0;
                totalDebit += debit || 0;

                return (
                  <tr key={khateName}>
                    <td style={{ border: "1px solid #000"}}>{khateName}</td>
                    <td style={{ border: "1px solid #000"}}>{formatNumber(credit)}</td>
                    <td style={{ border: "1px solid #000"}}>{formatNumber(debit)}</td>
                  </tr>
                );
              })}

              {/* Akher Shillak */}
              <tr
                style={{
                  backgroundColor: "#C5C6C7",
                }}
              >
                <td
                  style={{
                    fontWeight: "bold",border: "1px solid #000"
                  }}
                >
                  <b>{language === "English" ? "Final balance" : "अखेर शिल्लक"}</b>
                </td>
                <td style={{ border: "1px solid #000"}}>{" "}</td>
                <td style={{ border: "1px solid #000"}}>
                  {formatNumber(
                    (totalCredit + openingBalanceCredit + (attachedCredit ? studentFeeTotal : 0)) - 
                    totalDebit
                  )}
                </td> 
              </tr>

              <tr>
                <td
                  style={{
                    fontWeight: "bold",border: "1px solid #000"
                  }}
                >
                  {language === "English" ? "Total " : "एकूण "}
                </td>
                <td style={{ border: "1px solid #000"}}>
                  {formatNumber(
                    totalCredit + openingBalanceCredit + (attachedCredit ? studentFeeTotal : 0)
                  )}
                </td>
                <td style={{ border: "1px solid #000"}}>
                  {formatNumber(
                    totalDebit + 
                    ((totalCredit + openingBalanceCredit + (attachedCredit ? studentFeeTotal : 0)) - totalDebit)
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// ... (keep your existing style definitions)
export default TerijReport;

const report2Overlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backdropFilter: 'blur(3px)', // Blur effect
  zIndex: 1000, // Ensure it appears above other content
};

const report2Container = {
  background: 'white', // White background for the report
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  maxWidth: '900px', // Set a maximum width
  width: '100%', // Full width
  position: 'relative', // Position for the close button
  color: 'black',
  overflowY: 'hidden', 
  maxHeight: '90vh',
};

const closeButtonStyle2 = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  background: 'transparent',
  border: 'none',
  fontSize: '20px',
  cursor: 'pointer',
  color: 'Red'
};
